(ns manatee.components.modal.subs
  (:require [manatee.components.modal.db :as db]
            [re-frame.core :as rf]))

(rf/reg-sub
 ::visible?
 (fn [db [_ banner-id]]
   (db/visible? db banner-id)))

(rf/reg-sub
 ::modal-props
 (fn [db _]
   (db/modal-props db)))
